export const scrollToContactForm = () => {
  const el = document.getElementById('contact-form');
  el!.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'start'});
}
